/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "_" }]*/
import { FromJsonTypeMapping, QuestionType, QuestionTypeDefinition, ToJsonTypeMapping } from './questions';

const uuidv4 = () => crypto.randomUUID();

export const Actions = {
    INITIAL_LOAD: 'INITIAL_LOAD',
    TOGGLE_SAVING: 'TOGGLE_SAVING',

    RENAME_CHECKLIST: 'RENAME_CHECKLIST',
    TOGGLE_CHECKLIST_INACTIVE: 'TOGGLE_CHECKLIST_INACTIVE',

    CREATE_GROUP: 'CREATE_GROUP',
    CREATE_OPTION: 'CREATE_OPTION',
    CREATE_QUESTION: 'CREATE_QUESTION',

    DELETE_GROUP: 'DELETE_GROUP',
    DELETE_OPTION: 'DELETE_OPTION',
    DELETE_QUESTION: 'DELETE_QUESTION',

    MOVE_GROUP: 'MOVE_GROUP',
    MOVE_QUESTION: 'MOVE_QUESTION',

    UPDATE_GROUP: 'UPDATE_GROUP',
    UPDATE_OPTION: 'UPDATE_OPTION',
    UPDATE_QUESTION: 'UPDATE_QUESTION',

    SORT_GROUPS: 'SORT_GROUPS',
    SORT_OPTIONS: 'SORT_OPTIONS',
    SORT_QUESTIONS: 'SORT_QUESTIONS',
};

export function checklistEditorReducer(state, action) {
    const {
        type,
        payload,
    } = action;

    switch (type) {
        case Actions.INITIAL_LOAD: {
            return {
                ...state,
                ...payload,
            };
        }

        case Actions.RENAME_CHECKLIST: {
            const { title } = payload;
            return {
                ...state,
                title,
            };
        }

        case Actions.TOGGLE_CHECKLIST_INACTIVE: {
            const { inactive } = payload;
            return {
                ...state,
                inactive,
            };
        }

        case Actions.TOGGLE_SAVING: {
            const { saving } = payload;
            return {
                ...state,
                saving,
            };
        }

        case Actions.CREATE_GROUP: {
            const groupId = uuidv4();

            return {
                ...state,
                groupsById: {
                    ...state.groupsById,
                    [groupId]: {
                        id: groupId,
                        name: `New Group`,
                    },
                },
                groupOrder: [ ...state.groupOrder, groupId ],
                questionOrderByGroupId: {
                    ...state.questionOrderByGroupId,
                    [groupId]: [],
                },
            };
        }

        case Actions.CREATE_OPTION: {
            const optionId = uuidv4();
            const {
                questionId,
                label,
            } = payload;

            return {
                ...state,
                optionsByQuestionId: {
                    ...state.optionsByQuestionId,
                    [questionId]: {
                        ...state.optionsByQuestionId[questionId],
                        [optionId]: {
                            id: optionId,
                            label: label,
                        },
                    }
                },
                optionOrderByQuestionId: {
                    ...state.optionOrderByQuestionId,
                    [questionId]: [ ...state.optionOrderByQuestionId[questionId], optionId ],
                },
            };
        }

        case Actions.CREATE_QUESTION: {
            const questionId = uuidv4();
            const {
                type,
                groupId,
            } = payload;

            return {
                ...state,
                questionsById: {
                    ...state.questionsById,
                    [questionId]: {
                        type: type,
                        id: questionId,
                        name: `New Question`,
                    },
                },
                optionsByQuestionId: {
                    ...state.optionsByQuestionId,
                    [questionId]: {},
                },
                optionOrderByQuestionId: {
                    ...state.optionOrderByQuestionId,
                    [questionId]: [],
                },
                questionOrderByGroupId: {
                    ...state.questionOrderByGroupId,
                    [groupId]: [ ...state.questionOrderByGroupId[groupId], questionId ],
                },
            };
        }

        case Actions.MOVE_GROUP: {
            const {
                from,
                to,
            } = payload;

            return {
                ...state,
                groupOrder: moveItem(state.groupOrder, from, to),
            };
        }

        case Actions.MOVE_QUESTION: {
            const {
                groupId,
                from,
                to,
            } = payload;

            return {
                ...state,
                questionOrderByGroupId: {
                    ...state.questionOrderByGroupId,
                    [groupId]: moveItem(state.questionOrderByGroupId[groupId], from, to),
                },
            };
        }

        case Actions.UPDATE_GROUP: {
            const {
                groupId,
                ...changes
            } = payload;

            return {
                ...state,
                groupsById: {
                    ...state.groupsById,
                    [groupId]: {
                        ...state.groupsById[groupId], ...changes,
                    },
                },
            };
        }

        case Actions.UPDATE_OPTION: {
            const {
                optionId,
                questionId,
                ...changes
            } = payload;

            return {
                ...state,
                optionsByQuestionId: {
                    ...state.optionsByQuestionId,
                    [questionId]: {
                        ...state.optionsByQuestionId[questionId],
                        [optionId]: {
                            ...state.optionsByQuestionId[questionId][optionId],
                            ...changes,
                        },
                    }
                },
            };
        }

        case Actions.UPDATE_QUESTION: {
            const {
                questionId,
                ...changes
            } = payload;

            return {
                ...state,
                questionsById: {
                    ...state.questionsById,
                    [questionId]: {
                        ...state.questionsById[questionId], ...changes,
                    },
                },
            };
        }

        case Actions.DELETE_OPTION: {
            const {
                optionId,
                questionId,
            } = payload;

            const {
                [optionId]: _,
                ...remainingOptions
            } = state.optionsByQuestionId[questionId];

            return {
                ...state,
                optionsByQuestionId: {
                    ...state.optionsByQuestionId,
                    [questionId]: remainingOptions,
                },
                optionOrderByQuestionId: {
                    ...state.optionOrderByQuestionId,
                    [questionId]: state.optionOrderByQuestionId[questionId].filter(id => id !== optionId),
                },
            };
        }

        case Actions.DELETE_QUESTION: {
            const {
                questionId,
                groupId,
            } = payload;

            const {
                [questionId]: _,
                ...remainingQuestions
            } = state.questionsById;

            return {
                ...state,
                questionsById: remainingQuestions,
                questionOrderByGroupId: {
                    ...state.questionOrderByGroupId,
                    [groupId]: state.questionOrderByGroupId[groupId].filter(id => id !== questionId),
                },
            };
        }

        case Actions.DELETE_GROUP: {
            const { groupId } = payload;
            const {
                [groupId]: _,
                ...remainingGroups
            } = state.groupsById;

            return {
                ...state,
                groupsById: remainingGroups,
                groupOrder: state.groupOrder.filter(id => id !== groupId),
            };
        }

        case Actions.SORT_GROUPS: {
            const {
                from,
                to,
            } = payload;
            return {
                ...state,
                groupOrder: moveItem(state.groupOrder, from, to),
            };
        }

        case Actions.SORT_OPTIONS: {
            const {
                questionId,
                from,
                to,
            } = payload;
            return {
                ...state,
                optionOrderByQuestionId: {
                    ...state.optionOrderByQuestionId,
                    [questionId]: moveItem(state.optionOrderByQuestionId[questionId], from, to),
                },
            };
        }

        case Actions.SORT_QUESTIONS: {
            const {
                groupId,
                from,
                to,
            } = payload;
            return {
                ...state,
                questionOrderByGroupId: {
                    ...state.questionOrderByGroupId,
                    [groupId]: moveItem(state.questionOrderByGroupId[groupId], from, to),
                },
            };
        }

        default:
            throw new Error(`Dispatcher action '${ type }' isn't supported`);
    }
}

const moveItem = (order, fromIndex, toIndex) => {
    const length = order.length;
    const sourceOutOfBounds = fromIndex < 0 || fromIndex >= length;
    const destinationOutOfBounds = toIndex < 0 || toIndex >= length;

    if (sourceOutOfBounds || destinationOutOfBounds || fromIndex === toIndex) {
        return order;
    }

    const next = order.slice();
    const [ moved ] = next.splice(fromIndex, 1);
    next.splice(toIndex, 0, moved);

    return next;
};


export const groupsInChecklist = state => state.groupOrder?.map(groupId => state.groupsById[groupId]) ?? [];
export const questionsInGroup = (state, groupId) => state.questionOrderByGroupId[groupId]?.map(questionId => state.questionsById[questionId]) ?? [];
export const optionsInQuestion = (state, questionId) => state.optionOrderByQuestionId[questionId]?.map(optionId => state.optionsByQuestionId[questionId][optionId]) ?? [];

export const unserialiseChecklistForInitialState = (json) => {
    let rawChecklist = {};

    try {
        if ('' === json.trim()) {
            return rawChecklist;
        }

        rawChecklist = JSON.parse(json);
    } catch (e) {
        console.error(`Failed to unserialise checklist JSON`, e);
    }

    const initialState = {
        groupsById: {},
        optionsByQuestionId: {},
        questionsById: {},

        groupOrder: [],
        questionOrderByGroupId: {},
        optionOrderByQuestionId: {},
    };

    const unserialiseOption = (questionId, rawOption) => {
        // The option id is only needed in the frontend, so we can generate a stable but disposable one here.
        const option = {
            id: rawOption.id,
            label: rawOption.option,
        };

        initialState.optionsByQuestionId[questionId][option.id] = option;
        initialState.optionOrderByQuestionId[questionId].push(option.id);
    };

    const unserialiseQuestion = (groupId, rawQuestion) => {
        const question = {
            id: rawQuestion.id,
            name: rawQuestion.question,
            type: FromJsonTypeMapping[rawQuestion.type],
        };

        initialState.optionsByQuestionId[question.id] = {};
        initialState.optionOrderByQuestionId[question.id] = [];

        if (QuestionType.TOGGLE === question.type) {
            // Nothing custom to do for a toggle question, AFAIK.
        }

        if ([ QuestionType.DROPDOWN, QuestionType.MULTIPLE_CHOICE ].includes(question.type)) {
            if ('options' in rawQuestion && rawQuestion.options?.length > 0) {
                rawQuestion.options.forEach(rawOption => unserialiseOption(question.id, rawOption));
            }
        }

        if (!(question.type in QuestionTypeDefinition)) {
            console.error(`No question type mapping for ${ question.type } (raw: ${ rawQuestion.type })`);

            // NOTE: Falling back to a simple "text" type question to avoid crashing the page.
            question.type = 'text';
        }

        initialState.questionsById[question.id] = question;
        initialState.questionOrderByGroupId[groupId].push(question.id);
    };

    if ('groups' in rawChecklist && rawChecklist.groups?.length > 0) {
        rawChecklist.groups.forEach((rawGroup) => {
            const group = {
                id: rawGroup.id,
                name: rawGroup.name,
                questions: [],
            };

            initialState.questionOrderByGroupId[group.id] = [];

            if ('questions' in rawGroup && rawGroup.questions?.length > 0) {
                rawGroup.questions.forEach(rawQuestion => unserialiseQuestion(group.id, rawQuestion));
            }

            // TODO: Sort groups and questions by order, in case they aren't already sorted.
            //       This is done by iterating a sorted copy of the groupsById/questionsById and populating
            //       the groupOrder/questionOrderByGroupId array with the ids in the desired order.
            initialState.groupsById[group.id] = group;
            initialState.groupOrder.push(group.id);
        });
    }

    return initialState;
};

export const serialiseChecklist = (state) => {
    const serialiseOption = (option, optionRank) => {
        return {
            'id': option.id,
            'option': option.label,
            'order': optionRank + 1,
        };
    };

    const serialiseQuestion = (question) => {
        if (QuestionType.TEXT === question.type) {
            return {
                ...question,
                'type': ToJsonTypeMapping[question.type],
                'validation': 'text',
            };
        }

        if (QuestionType.TOGGLE === question.type) {
            return {
                ...question,
                type: ToJsonTypeMapping[question.type],
            };
        }

        if ([ QuestionType.DROPDOWN, QuestionType.MULTIPLE_CHOICE ].includes(question.type)) {
            return {
                ...question,
                'type': ToJsonTypeMapping[question.type],
                'options': optionsInQuestion(state, question.id).map(serialiseOption),
            };
        }

        throw new Error(`TODO: Add support to serialise ${ question.type }`);
    };

    return {
        '$version': 2,
        'groups': groupsInChecklist(state).map((group, groupRank) => {
            return {
                'id': group.id,
                'order': groupRank + 1,
                'name': group.name,
                'questions': questionsInGroup(state, group.id).map((question, questionRank) => serialiseQuestion({
                    'id': question.id,
                    'type': question.type,
                    'question': question.name,
                    'order': questionRank + 1,
                })),
            };
        }),
    };
};
